export const capitalizeString = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const normalizeSpaces = (str) => {
  if (!str) return '';
  return str.replace(/\s+/g, ' ').trim();
};